<app-admin-list-page [title]="'Educations' | translate">

  <button slot="actions" class="btn btn-primary" (click)="addEducationProgram()">
    {{'Add' | translate}}
  </button>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
